/* eslint-disable no-console */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setItem } from 'src/indexDb/db';
import axios from 'src/workspace/axios';
import { getTransformedSearchResults } from './queries';
import {
  setCalenderTokens,
  setNotifications,
  setSearchError,
  setSearchLoading,
  setSearchResults,
  setSearchWorkflowSummary,
  setSuggestions,
  setSuperSetDetails,
} from './slice';

export const fetchNudges = createAsyncThunk(
  'navbar/fetchNudges',
  async (
    {
      nudgeType,
    }: {
      nudgeType: 'NOTIFICATION' | 'SUGGESTION';
    },
    { dispatch },
  ) => {
    try {
      const payload = {
        nudgeType,
        showMore: false,
        timeStamp: Date.now(),
        actionData: {},
        actionRequest: null,
        source: 'web',
      };

      const response: any = await axios.post('/v3/nudges', payload);
      const { data } = response;

      if (nudgeType === 'NOTIFICATION') {
        dispatch(
          setNotifications({
            notifications: data.notifications,
            filters: data.filters,
          }),
        );
      } else {
        dispatch(
          setSuggestions({
            suggestions: data.suggestions,
            filters: data.filters,
          }),
        );
      }
    } catch (error) {
      console.error('Error fetching nudges', error);
    }
  },
);

export const fetchSearchResults = createAsyncThunk(
  'navbar/fetchSearchResults',
  async (
    {
      query,
      params,
      minCharsRequired,
      type,
    }: {
      query: string;
      params?: any;
      minCharsRequired: number;
      type: string;
    },
    { dispatch },
  ) => {
    try {
      if (query && query.length >= minCharsRequired) {
        // based on type update the url & transform the response.data
        dispatch(setSearchLoading(true));
        let results: any = null;

        if (type === 'legacy') {
          const searchParams = new URLSearchParams({
            q: query,
            ...params,
          });

          const response = await axios.get(
            `/search?${searchParams.toString()}`,
          );
          const { data } = response;
          results = data.results;
        } else {
          const body = {
            searchText: query,
            limit: 50,
            source: 'web',
            workflowTypes: (params?.modules_code || '')
              ?.split(',')
              .filter(Boolean),
            timestamp: new Date().getTime(),
          };

          const response: any = await axios.post(
            `/vymo/v3/workflow/search`,
            body,
          );
          results = getTransformedSearchResults(
            response?.data?.payload?.result || [],
          );
          dispatch(
            setSearchWorkflowSummary(
              response?.data?.payload?.workflowSummary || [],
            ),
          );
        }

        if (!results) {
          dispatch(setSearchError('error'));
        } else {
          dispatch(setSearchResults(results || []));
          setItem('SEARCH_HISTORY', results);
        }
        dispatch(setSearchLoading(false));
      } else {
        dispatch(setSearchResults([]));
        dispatch(setSearchWorkflowSummary([]));
      }
    } catch (error) {
      console.error('Error fetching search results', error);
      dispatch(setSearchError('error'));
    }
  },
);

export const fetchAllTokens = createAsyncThunk(
  'navbar/fetchAllTokens',
  async (_: void, { dispatch }) => {
    try {
      const response = await axios.get('/token/user/all');
      const { tokens } = response.data || {};

      dispatch(setCalenderTokens(tokens || []));

      return tokens;
    } catch (error) {
      console.error('Error fetching tokens', error);
      dispatch(setCalenderTokens([]));
      throw error;
    }
  },
);

export const disconnectAccountThunk = createAsyncThunk(
  'navbar/disconnect',
  async (type: string) => {
    await axios.post(
      '/token/user/delete',
      {},
      {
        params: { type },
      },
    );
    return type;
  },
);

export const subscribeOutlook = createAsyncThunk(
  'navbar/subscribeOutlook',
  async () => {
    const params = { type: 'outlook' };

    const res = await axios.get('workaccount/user/generate-token', {
      params,
    });

    return res.data;
  },
);

export const logout = createAsyncThunk('home/logout', async () => {
  await axios.get('/logout');
});

export const superSetLogin = createAsyncThunk(
  'navbar/supersetLogin',
  async (
    {
      params,
    }: {
      params?: any;
    },
    { dispatch },
  ) => {
    try {
      const response = await axios.get('/superset/v1/login', { params });
      dispatch(setSuperSetDetails(response.data));
    } catch (error) {
      console.error('Error fetching search results', error);
      dispatch(setSearchError('error'));
    }
  },
);
